module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Nachricht")])]), _vm._v(" "), _c('div', {
    class: {
      'col-sm-10': _vm.showButtons, 'col-sm-12': !(_vm.showButtons)
    },
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "message-wraper"
  }, [(_vm.showOptionsMsgKeywords) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageStatus),
      expression: "messageStatus"
    }],
    staticClass: "form-control text-left",
    class: {
      'cc-required': _vm.requiredOptionsMsgKeywords
    },
    staticStyle: {
      "width": "50%"
    },
    on: {
      "input": _vm.onUpdateStatus,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.messageStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.optionsMsgKeywords), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "textContent": _vm._s(option)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "message-wraper",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "idmessage",
      "rows": "7",
      "placeholder": "Nachricht eingeben..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }, _vm.onUpdate]
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "btn btn-default",
    staticStyle: {
      "position": "absolute",
      "bottom": "10px",
      "right": "10px",
      "border": "0 none"
    },
    attrs: {
      "type": "button",
      "title": "Nachricht löschen"
    },
    on: {
      "click": _vm.onClickClearMessage
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showButtons),
      expression: "showButtons"
    }],
    staticClass: "col-sm-2 text-center cc-call-buttons",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "type": "button",
      "title": "Anruf abschließen"
    },
    on: {
      "click": _vm.onHitCompletion
    }
  }, [_c('i', {
    staticClass: "fa fa-send fa-lg ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.showTrashButton,
      "title": "Papierkorb"
    },
    on: {
      "click": _vm.onHitTrash
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": !_vm.showParkingButton,
      "title": "Parken"
    },
    on: {
      "click": _vm.onHitParking
    }
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-danger btn-block",
    staticStyle: {
      "position": "absolute",
      "bottom": "-15px",
      "right": "15px",
      "width": "calc(100% - 30px)"
    },
    attrs: {
      "type": "button",
      "title": "Abbruch"
    },
    on: {
      "click": _vm.onHitCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.showModal) ? _c('cc-message-modal', {
    on: {
      "send": function($event) {
        _vm.showModal = false
      },
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exitState == 'completion'),
      expression: "exitState == 'completion'"
    }]
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button",
      "title": "Anruf abschließen"
    }
  }, [_c('i', {
    staticClass: "fa fa-send fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n        Call Abschließen\n      ")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exitState == 'trash'),
      expression: "exitState == 'trash'"
    }]
  }, [_c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "type": "button",
      "title": "Papierkorb"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n        Call in Papierkorb\n      ")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exitState == 'parking'),
      expression: "exitState == 'parking'"
    }]
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "title": "Parken"
    }
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n        Call wird geparkt\n      ")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exitState == 'abort'),
      expression: "exitState == 'abort'"
    }]
  }, [_c('button', {
    staticClass: "btn  btn-danger btn-lg",
    attrs: {
      "type": "button",
      "title": "Abbruch"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n        Call wird abgebrochen!\n      ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.showModalSpinner) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-5x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.errorMsg), function(msg) {
    return _c('div', {
      staticClass: "alert cc-attention "
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-warning-sign",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(msg)
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.warningMsg), function(msg) {
    return _c('div', {
      staticClass: "alert cc-attention"
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-info-sign",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('strong'), _vm._v(_vm._s(msg) + "\n      ")])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSendCallButton),
      expression: "!showSendCallButton"
    }],
    staticClass: "alert alert-danger text-left"
  }, [_c('span', [_vm._v("Anruf kann nicht abgeschlossen werden!")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWarningButton),
      expression: "showWarningButton"
    }],
    staticClass: "btn btn-warning",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendCall(_vm.exitState)
      }
    }
  }, [_vm._v("Trotz Warnung abschließen!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Schließen")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0f2e018!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Message.vue
// module id = 285
// module chunks = 0